import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Planejamento de Inventário de Bens',
  path: '/patrimonio/relatorioplanejamentoinventario',
  name: 'patrimonio-relatorio-planejamento-inventario',
  component: () => import('@/views/patrimonio/relatorioplanejamentoinventario/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.PLANEJAMENTOPATRIMONIALNOVO_MENU_1200200299],
  },
  goesToMenu: true,
 },
]
